import { useSyncExternalStore } from 'react';

const SMALL_SCREEN_QUERY = '(max-width: 550px)';

const subscribe = (onChange: () => void): (() => void) => {
  if (typeof globalThis.matchMedia !== 'function') {
    return () => undefined;
  }
  const media = globalThis.matchMedia(SMALL_SCREEN_QUERY);
  media.addEventListener('change', onChange);
  return () => media.removeEventListener('change', onChange);
};

const getSnapshot = (): boolean =>
  typeof globalThis.matchMedia === 'function' && globalThis.matchMedia(SMALL_SCREEN_QUERY).matches;

export const useIsSmallScreen = (): boolean =>
  useSyncExternalStore(subscribe, getSnapshot, () => false);
